import { makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import RoundedButton from 'components/Shared/RoundedButton';
import Modal from 'components/Shared/Modal';
import { useSelector } from 'react-redux';
import WarningIcon from '@material-ui/icons/Warning';

const useStyles = makeStyles(theme => ({
  modal: {
    width: '100%',
    minWidth: 400,
    maxWidth: 500,
    height: 'auto',
    borderRadius: 12,
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.15)',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  content: {
    padding: theme.spacing(3, 4),
    background: '#ffffff',
    width: '100%',
    textAlign: 'center',
  },
  warningIcon: {
    fontSize: 48,
    color: '#f59e0b',
    marginBottom: theme.spacing(2),
  },
  title: {
    fontSize: 20,
    fontWeight: 600,
    color: '#1f2937',
    marginBottom: theme.spacing(1),
    margin: 0,
  },
  message: {
    fontSize: 14,
    color: '#6b7280',
    lineHeight: 1.5,
    margin: 0,
  },
  actionsContainer: {
    padding: theme.spacing(2, 3),
    background: '#f9fafb',
    borderTop: '1px solid #e5e7eb',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexShrink: 0,
  },
  actionButton: {
    textTransform: 'uppercase',
    borderRadius: 8,
    padding: theme.spacing(1.5, 2),
    letterSpacing: 1.5,
    fontWeight: 600,
    fontSize: 14,
    minWidth: 100,
    height: 40,
  },
  keepEditingButton: {
    // Gray outlined button styles - will use default RoundedButton outlined style
  },
  discardButton: {
    backgroundColor: '#dc3545',
    borderColor: '#dc3545',
    color: 'white',
    '&:hover': {
      backgroundColor: '#c82333',
      borderColor: '#bd2130',
    },
  },
}));

const UnsavedChangesModal = ({
  open,
  onDiscard,
  onKeepEditing,
  title = 'Unsaved changes',
  message = 'Your changes will be lost if you leave.',
  discardButtonText = 'Leave',
  keepEditingButtonText = 'Stay',
}) => {
  const classes = useStyles();
  const {
    en: { btn },
  } = useSelector(state => state.i18n);

  return (
    <Modal open={open} classes={{ paper: classes.modal }} handleClose={onKeepEditing}>
      <div className={classes.content}>
        <WarningIcon className={classes.warningIcon} />
        <h3 className={classes.title}>{title}</h3>
        <p className={classes.message}>{message}</p>
      </div>

      <div className={classes.actionsContainer}>
        <RoundedButton
          variant="outlined"
          color="primary"
          onClick={onKeepEditing}
          className={classes.actionButton}
        >
          {keepEditingButtonText || btn.cancel || 'Stay'}
        </RoundedButton>
        <RoundedButton
          variant="contained"
          onClick={onDiscard}
          className={`${classes.actionButton} ${classes.discardButton}`}
        >
          {discardButtonText || 'Leave'}
        </RoundedButton>
      </div>
    </Modal>
  );
};

UnsavedChangesModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onDiscard: PropTypes.func.isRequired,
  onKeepEditing: PropTypes.func.isRequired,
  title: PropTypes.string,
  message: PropTypes.string,
  discardButtonText: PropTypes.string,
  keepEditingButtonText: PropTypes.string,
};

export default UnsavedChangesModal;
